import axios from '@fs/zion-axios'

// TODO: Currently gedcomData is only available to the owner.

/**
 * @typedef {'SUCCEEDED' | 'FAILED' | 'IN_PROGRESS' | 'INTERRUPTED'} Status
 * @typedef {{fileName: string; uploadDate: string; status: Status; errorCount: number}} GedcomData
 */

/**
 * @param {string} treeId
 * @returns {GedcomData}
 */

export default async function getGedcomData(treeId) {
  const results = await axios
    .get(`/service/tree/gedcom/upload/results/errors?treeId=${treeId}`)
    .then(
      ({
        data: {
          fileName,
          modified,
          status,
          personFailedCount,
          personFactFailedCount,
          coupleRelationshipFailedCount,
          coupleFactFailedCount,
          parentChildRelationshipFailedCount,
          parentChildFactFailedCount,
          sourceFailedCount,
          sourceAttachFailedCount,
          sourceTagFailedCount,
          noteFailedCount,
          associationRelationshipFailedCount,
          errorReviewDone,
        },
      }) => {
        const uploadDate = modified.slice(0, 10) // gets date without time
        const errorCount =
          personFailedCount +
          personFactFailedCount +
          coupleRelationshipFailedCount +
          coupleFactFailedCount +
          parentChildRelationshipFailedCount +
          parentChildFactFailedCount +
          sourceFailedCount +
          sourceAttachFailedCount +
          sourceTagFailedCount +
          noteFailedCount +
          associationRelationshipFailedCount
        return { fileName, uploadDate, status, errorCount, errorReviewDone }
      }
    )
  return results
}
